import { render } from "./Sv030.vue?vue&type=template&id=0f72aeae&scoped=true"
import script from "./Sv030.vue?vue&type=script&lang=js"
export * from "./Sv030.vue?vue&type=script&lang=js"

import "./Sv030.vue?vue&type=style&index=0&id=0f72aeae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f72aeae"]])

export default __exports__